import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { generateHTMLIdFromKeyPath } from 'utils/idUtils';
import { INVALID_COMPONENT_CLASS } from 'utils/constants';
import CheckBoxAttribute from 'components/Fields/CheckBoxAttribute';
import TableRow from './Multipicklist.Row';

const CAP_VALUE = 7;

const MultipicklistTable = ({ keyPath, id, toggleableOptionIds, values: { options, optionsOrder }, uiState, ...props }) => {
  const [shouldCapRows, setshouldCapRows] = useState(optionsOrder.length - 1 > CAP_VALUE);

  useEffect(() => {
    setshouldCapRows(optionsOrder.length - 1 > CAP_VALUE);
  }, [optionsOrder.length]);

  const visibleOptions = shouldCapRows ? optionsOrder.slice(0, 7) : optionsOrder;
  const TableBody = visibleOptions.map((picklistId, idx, arr) => (
    <TableRow
      disableShouldDisplay={!options[picklistId] || !toggleableOptionIds.includes(picklistId)}
      key={picklistId}
      keyPath={keyPath}
      id={picklistId}
      idx={idx}
      onReorderMultipicklist={props.onReorderMultipicklist}
      totalRows={arr.length}
      values={options[picklistId] || {}}
      onChangeShouldDisplay={props.onChangeShouldDisplay}
      onChangeOptionLabel={props.onChangeOptionLabel}
      onFieldUIStateChange={props.onFieldUIStateChange}
      uiState={uiState.options[picklistId] || {}}
    />
  ));

  const selectedOptions = Object.values(options).filter((opt) => opt.shouldDisplay);
  const markTableInvalid = uiState.options.isValid === false;
  return (
    <div id={generateHTMLIdFromKeyPath([...keyPath, 'options'])} className={`col-12 ${markTableInvalid ? INVALID_COMPONENT_CLASS : ''}`}>
      <p className="font-weight-bold mb-1">Values to Include</p>
      <table className="table bg-white">
        <thead>
          <tr>
            <th scope="col" className="align-top">
              <CheckBoxAttribute
                keyPath={[...keyPath, 'toggle-all-options']}
                onCheckBoxChange={props.onToggleBulkShouldDisplay}
                value={selectedOptions.length === optionsOrder.length}
              />
            </th>
            <th className="w-25" scope="col">Value</th>
            <th className="w-50" scope="col">Display Name</th>
            <th scope="col"> </th>
          </tr>
        </thead>
        <tbody>
          {TableBody}
        </tbody>
      </table>
      {shouldCapRows ? (
        <button
          className="text-primary mb-2"
          type="button"
          onClick={() => setshouldCapRows(false)}
        > + {optionsOrder.length - CAP_VALUE} more
        </button>
      ) :
        null}
      {markTableInvalid ? <span className="invalid-feedback d-block">{uiState.options.errorDisplay}</span> : null}
    </div>
  );
};

MultipicklistTable.propTypes = {
  keyPath: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  onChangeOptionLabel: PropTypes.func.isRequired,
  onChangeShouldDisplay: PropTypes.func.isRequired,
  onFieldUIStateChange: PropTypes.func.isRequired,
  onReorderMultipicklist: PropTypes.func.isRequired,
  onToggleBulkShouldDisplay: PropTypes.func.isRequired,
  uiState: PropTypes.object.isRequired,
  values: PropTypes.shape({
    options: PropTypes.object.isRequired,
    optionsOrder: PropTypes.array.isRequired,
  }).isRequired,
  toggleableOptionIds: PropTypes.array.isRequired,
};

export default MultipicklistTable;
